import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { XpoAuthenticationGuard } from '@xpo/ngx-auth';
import { MainComponent } from './main/main.component';
import {SearchComponent} from './search/search.component';
import { XpoLtlAuthGuard } from '@xpo-ltl/ngx-auth';

const routes: Routes = [
  /*{
    path: 'main',
    component: MainComponent,
    canActivate: [XpoAuthenticationGuard],
  },*/
  {
    path: 'search',
    component: SearchComponent,
    canActivate: [XpoAuthenticationGuard,XpoLtlAuthGuard],
  },
  { path: '', redirectTo: 'search', pathMatch: 'full' },

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
